import { priceConstants } from '../constants';
import { priceService } from '../../services';

export const priceActions = {
  pricesList,
  addPrice,
  getPrice,
  updatePrice
}

/*
ACTION: Prices List
*/
function pricesList() {
  return dispatch => {
    dispatch(request());
    return priceService.pricesList()
      .then(
        response => {
          dispatch(success(response.data.body.prices, 3));
        },
        error => {
          dispatch(failure(error));
        }
      )
  }

  function request() { return { type: priceConstants.GETALL_REQUEST } }
  function success(items, total) { return { type: priceConstants.GETALL_SUCCESS, items, total } }
  function failure(error) { return { type: priceConstants.GETALL_FAILURE, error } }
}

/*
ACTION: Add Price
*/
function addPrice(addToast, formData) {
  return dispatch => {
    dispatch(request());
    return priceService.addPrice(formData)
      .then(
        response => {
          addToast('عملیات با موفقیت انجام شد.', { appearance: "success", autoDismiss: true });
          dispatch(success(true, response.data.body));
        },
        error => {
          if (typeof error !== 'object' || !error) {
            addToast('خطا در برقراری اتصال با سرور!', { appearance: 'error', autoDismiss: true });
          }
          dispatch(failure(error));
        }
      )
  }

  function request() { return { type: priceConstants.ADD_REQUEST } }
  function success(status, item) { return { type: priceConstants.ADD_SUCCESS, status, item } }
  function failure(error) { return { type: priceConstants.ADD_FAILURE, error } }
}

/*
ACTION: Get Price By ID
*/
function getPrice(addToast, priceID) {
  return dispatch => {
    dispatch(request());
    return priceService.getPrice(priceID)
      .then(
        response => {
          // console.log(response);
          dispatch(success(response.data.body));
        },
        error => {
          if(typeof error === 'object') {
            Object.keys(error).map(key => {
              addToast(error[key], { appearance: 'error', autoDismiss: true });
            })
          } else {
            addToast('خطا در برقراری اتصال با سرور!', { appearance: 'error', autoDismiss: true });
          }
          dispatch(failure(error));
        }
      )
  }

  function request() { return { type: priceConstants.GET_REQUEST } }
  function success(item) { return { type: priceConstants.GET_SUCCESS, item } }
  function failure(error) { return { type: priceConstants.GET_FAILURE, error } }
}

/*
ACTION: Update Price
*/
function updatePrice(addToast, formData) {
  return dispatch => {
    dispatch(request());
    return priceService.updatePrice(formData)
      .then(
        response => {
          addToast('بروزرسانی با موفقیت انجام شد.', { appearance: "success", autoDismiss: true });
          dispatch(success(true, response.data.body));
        },
        error => {
          if (typeof error !== 'object' || !error) {
            addToast('خطا در برقراری اتصال با سرور!', { appearance: 'error', autoDismiss: true });
          }
          dispatch(failure(error));
        }
      )
  }

  function request() { return { type: priceConstants.UPDATE_REQUEST } }
  function success(status, item) { return { type: priceConstants.UPDATE_SUCCESS, status, item } }
  function failure(error) { return { type: priceConstants.UPDATE_FAILURE, error } }
}